
import { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './AboutPage.css';
import contact from '../assets/contact.png';
import about1 from '../assets/about1.jpg';
import service2 from '../assets/service9.jpg';
import service3 from '../assets/service10.jpg';
import service4 from '../assets/service11.png';
import service5 from '../assets/service12.jpg';
import service1 from '../assets/service1.png';
import team1 from '../assets/team1.jpg';
import team2 from '../assets/team2.jpg'
import team3 from '../assets/team3.jpg'
import team4 from '../assets/team4.jpg'
import team5 from '../assets/team5.jpg'
import team6 from '../assets/team6.jpg'
import team7 from '../assets/team7.jpg'
import team8 from '../assets/team8.jpg'
import team9 from '../assets/team9.jpg'
import team10 from '../assets/team10.jpg'
import team11 from '../assets/team11.jpg'
import team12 from '../assets/team12.jpg'


// Added ↓
import Header from "../components/Header";
import Footer from "../components/Footer";

export default function AboutPage() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
      easing: 'ease-in-out'
    });
  }, []);

  const stats = [
    { icon: '📋', number: '54+', label: 'Years Experienced' },
    { icon: '👥', number: '25+', label: 'Service Teams' },
    { icon: '👍', number: '500+', label: 'Reviews' },
    { icon: '⭐', number: '5', label: 'Star Reviews on Google' },
    { icon: '🏆', number: '', label: 'Award Winning After-Care' }
  ];

  const values = [
    { icon: '❄️', title: 'Commercial & Residential AC Installation', image: about1 },
    { icon: '🏢', title: 'Authorized Brand Servicing (Samsung & Carrier)', image: service2 },
    { icon: '🔧', title: 'Duct Manufacturing & Supply', image: service3 },
    { icon: '⚡', title: 'Support Services for Builders & Project Contractors', image: service1 },
    { icon: '✅', title: 'Quality Guarantee', image: service4},
    { icon: '💰', title: 'Affordable Pricing', image: service5 }
  ];

 const teamMembers = [
  { img: team1, name: "Mr. Umesh ", role: "Service & Maintenance Specialist – Manages AMC, breakdown service, and preventive maintenance." },
  { img: team2, name: "Mr. Rajil", role: "Project Coordination Specialist – Manages timelines, teams, and site execution." },
  { img: team3, name: "Mr. Ravi", role: "Troubleshooting Specialist – Diagnoses and fixes technical faults." },
  { img: team4, name: "Mr. Dhanush", role: "Cassette & Split AC Specialist – Focuses on indoor unit selection and installation." },
  { img: team5, name: "Mr. Moorthy", role: "VRF/VRV System Specialist – Expert in advanced multi-zone AC systems." },
  { img: team6, name: "Mr. Sarath ", role: "HVAC Design Specialist – Plans AC system layouts and load calculations for projects." },
  { img: team7, name: "Mr. Chinna Mani", role: "Chiller System Specialist – Handles large centralized cooling systems for malls and hospitals." },
  { img: team8, name: "Mr. Surendren ", role: "Sales Application Specialist – Suggests the right AC solutions to customers." },
  { img: team9, name: "Mr. Munisamy ", role: "Service & Maintenance Specialist – Manages AMC, breakdown service, and preventive maintenance." },
  { img: team10, name: "Mr. Bala Murugan ", role: "Installation Specialist – Handles site installation and proper equipment setup." },
  { img: team11, name: "Mr. Kavi Pandi ", role: "Air Quality Specialist – Improves ventilation, filtration, and indoor air quality" },
  { img: team12, name: "Mr. Manoj Kumar", role: "Installation Specialist – Handles site installation and proper equipment setup." },
];

  return (
    <>
      {/* Header Added */}
      

      <div className="about-page">
        <Header />
        <section className="hero-banner">
          <div className="banner-content">
            <div className="banner-left">
              <h1 className="banner-title" data-aos="fade-right">ABOUT US</h1>
              <div className="breadcrumb" data-aos="fade-right" data-aos-delay="200">
                <a href="/">Home</a>
                <span className="separator">›</span>
                <span>About Us</span>
              </div>
            </div>

            <div className="banner-right" data-aos="fade-left">
              <div className="banner-right">
                <img src={contact} alt="HVAC Technician" />
              </div>
            </div>
          </div>
        </section>

        <section className="content-section">
          <div className="container">
            <div className="about-content" data-aos="fade-up">
              <h2 className="section-title">About Sky Breeze - AC Service</h2>
              <p className="section-text">
               SkyBreeze AC Solutions is a professionally managed HVAC company with over 8+ years of industry experience, delivering reliable air-conditioning solutions for commercial, industrial, and residential projects across India. With a strong team of skilled technicians and a dedicated duct manufacturing unit, we specialize in end-to-end HVAC execution with a focus on quality, transparency, and long-term performance
              </p>
            </div>
          </div>

          <section className="values-section">
            <div className="container">
              <h2 className="section-title" data-aos="fade-up">Our Core Values</h2>
              <div className="values-grid">
                {values.map((value, index) => (
                  <div
                    key={index}
                    className="value-card"
                    style={{ backgroundImage: `url(${value.image})` }}
                  >
                    <div className="value-content-overlay">
                      <div className="value-icon">{value.icon}</div>
                      <h3 className="value-title">{value.title}</h3>
                      <p className="value-description">{value.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <div className="container">
            <div className="about-content" data-aos="fade-up">
              <h2 className="section-title">Why Choose Sky Breeze AC Solutions</h2>
              <p className="section-text">
                8+ Years of Pan-India Experience
                With over eight years in the HVAC field, Sky Breeze has successfully delivered high-value
                projects across luxury hotels, hospitals, industrial units, and commercial spaces throughout
                India—including top-tier sites like Taj Hotels. Our expertise spans across various sectors
                with consistent service quality.
                30+ Technicians with 10+ Years of Expertise
                Our team consists of highly experienced and well-trained professionals, each with more than
                a decade of hands-on knowledge in design, planning, and on-site execution. This depth of
                experience ensures flawless results even in complex and large-scale projects.
                Authorized Partner of Leading Brands (Samsung & Carrier)
                Top global brands trust us as their authorized service partner. Our organizational structure,
                team integrity, and systematic processes have earned us long-standing relationships with
                reputed manufacturers like Samsung and Carrier.
                Proven Commercial Project Expertise
                We proudly handle Annual Maintenance Contracts (AMCs) for luxury hotels and have been part
                of high-budget commercial installations, delivering projects with efficiency, safety, and
                complete documentation.
                Strong Team Coordination & Systematic Execution
                At Sky Breeze, every job is assigned based on skill mapping by team leaders. With a
                well-structured hierarchy and operational system in place, we ensure that every technician is
                aligned to the right task. This results in smooth workflows, happy clients, and quality work
                without supervision headaches.
                Transparent Reporting & Accountability
                From daily updates to reverse quotations reflecting any on-site changes or dropped
                implementations, we maintain 100% transparency with clients. You stay informed at every
                stage—no surprises, no gaps.
              </p>
            </div>
          </div>
        </section>
      </div>

      {/* Our Team Members Section */}
<section className="team-section">
  <div className="container">
    <h2 className="section-title" data-aos="fade-up">
      Our Team Members
    </h2>

   <div className="team-grid">
  {teamMembers.map((member, index) => (
    <div
      className="team-card"
      key={index}
      data-aos="zoom-in"
      data-aos-delay={index * 100}
    >
      <img src={member.img} alt={member.name} />

      <div className="team-overlay">
        <h3>{member.name}</h3>
        <p>{member.role}</p>
      </div>
    </div>
  ))}
</div>

  </div>
</section>


      {/* Footer Added */}
      <Footer />
    </>
  );
}
